import React from 'react'
import { bookedOnLabel, byBookedDate, scheduledForLabel } from './activityDisplay'

/**
 * The case's activities as LOG ENTRIES inside the Case Progress Tracker — the
 * case-manager copy of scale-portal's CaseActivityLog.
 *
 * READ-ONLY, DELIBERATELY. The tracker is a record — "detailed record of all
 * actions pending & taken" — and every other row in it is something that
 * happened, with a date, that you cannot act on. Creating, editing and
 * cancelling live behind the Activities button, so there is one place that
 * manages them and one place that reports them.
 *
 * WHY IT EXISTS AT ALL: the Add Activity form promises "Add to your calendar
 * and case timeline", and without this the case timeline half of that sentence
 * was not true in this portal — a saved activity appeared only on the Schedule
 * board.
 *
 * WHAT ADAM ASKED FOR ON 13 OCT
 *   - the date on the right is the date it was BOOKED, not the date it
 *     happens; the body carries "Scheduled for …" instead
 *   - no "NA" where a time would be — "it looks like broken"
 *   - the NOTE, which he asked for twice: "we need to see the note section in
 *     this view." Two lines, then an ellipsis
 *   - no dot: "why are we doing a purple dot here? Nothing else has a dot"
 */
const CaseActivityLog = ({ activities = [] }) => {
    if (!activities.length) return null

    return (
        <>
            {[...activities].sort(byBookedDate).map((a) => {
                const notes = String(a.notes || '').trim()
                return (
                    <div
                        key={a.id}
                        /* The same row shape as the log entries above — label
                           left, date right — so an activity reads as one more
                           thing that happened on the case, not as a widget. */
                        className="flex flex-col sm:flex-row gap-3 justify-between border-b last:border-0 py-3"
                    >
                        <div className="min-w-0 text-sm text-gray-700 space-y-1">
                            <p
                                className="truncate text-xs font-medium text-black"
                                title={a.display_title}
                            >
                                {a.display_title}
                                {a.method_label ? ` · ${a.method_label}` : ''}
                            </p>
                            <p className="text-xs font-medium text-gray-500">
                                {scheduledForLabel(a)}
                            </p>
                            {notes && (
                                <p
                                    title={notes}
                                    className="text-xs text-gray-500"
                                    /* line-clamp-2 is not in this build's CSS,
                                       so the clamp is set here rather than by
                                       a class that would render as nothing. */
                                    style={{
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {notes}
                                </p>
                            )}
                        </div>
                        <p className="flex-shrink-0 text-xs text-gray-500">
                            {bookedOnLabel(a, { withYear: false })}
                        </p>
                    </div>
                )
            })}
        </>
    )
}

export default CaseActivityLog
